import React from 'react';

import { Box, HStack, Icon } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';

import UnstyledButton from '../unstyled-button';

const Container = UnstyledButton.withConfig(() => ({
  paddingY: '5',
  borderBottomWidth: '1px',
  borderBottomColor: primitive.$greyFour,
}));

const MainContent = Box.withConfig(() => ({
  width: '90%',
  _text: {
    color: primitive.$greyOne,
    textAlign: 'left',
    textDecoration: 'none',
    isTruncated: true,
    noOfLines: 1,
  },
}));

export const ArrowButton: React.FC<React.PropsWithChildren<
  React.ComponentProps<typeof UnstyledButton>
>> = ({ children, ...props }) => (
  <Container {...props}>
    <HStack justifyContent="space-between" alignItems="center">
      <MainContent>{children}</MainContent>
      <Icon variant="next" color={getDesignToken('icon-default')} accessible={false} />
    </HStack>
  </Container>
);
